import { useQuery } from '@tanstack/react-query';
import { api } from '../../services/api';
import type { DashboardTrendsResponse } from '../../services/api/core-domains';

export const useDashboardTrends = () => {
  return useQuery<DashboardTrendsResponse>({
    queryKey: ['dashboard', 'trends'],
    queryFn: async () => api.dashboard.getTrends(),
    staleTime: 1000 * 60 * 5,
  });
};
